import { Send } from "react-feather";
import { get } from "react-scroll/modules/mixins/scroller";

// Live
const url = "https://apii.saturnnri.com/api";
const otp = "https://apii.saturnnri.com/api";
// const otp = "https://apii.saturnnri.com/api/investor";


//local
// const otp = "http://localhost:6060/api/investor";
// const otp = "http://localhost:6060/api";
// const url = "http://localhost:6060/api";
const auth = `${url}/auth`;

const ApiConfig = {
  baseURL: url,
  login: `${auth}/send-otp`,
  register: `${auth}/signup`,
  registerByAdmin: `${auth}/signup-by-admin`,
  verifyOtp: `${auth}/verify-otp`,
  createProfile: `${url}/create-profile`,
  getProfile: `${url}/get-profile`,
  createOrder: `${url}/create-order`,
  paymentSuccess: `${url}/payment/success`,
  getAvailability: `${url}/get-availability`,
  getMeetings: `${url}/get-meetings`,
  uploadKycDocuments: `${url}/uploadKycDocuments`,
  userList: `${url}/users`,
  kycList: `${url}/kyc-users`,
  kycRedirectUrl: `${url}/get-redirect-url`,
  document: `${url}/document`,
  approveKYC: `${url}/approve-kyc`,
  declineKYC: `${url}/decline-kyc`,
  addReferral: `${url}/add-referral`,
  getUserReferral: `${url}/get-user-referralls`,
  referralListAdmin: `${url}/referrals`,
  approveReferral: `${url}/approve-referral`,
  declineReferral: `${url}/unapprove-referral`,
  addRegulatory: `${url}/add-regulatory`,
  addTaxation: `${url}/add-taxation`,
  generateMeetingPdf: `${url}/generate-meeting-pdf`,
  getAdminMeetings: `${url}/get-admin-meetings`,
  addMOM: `${url}/add-meeting-minutes`,
  emailUploadFiles: `${url}/email-upload-files`,
  userDetail: `${url}/user`,
  addInvestment: `${url}/add-investment`,
  uploadRtaFeed: `${url}/admin/upload-rta-feed`,
  rtaHoldings: `${url}/admin/rta-holdings`,
  getInvestment: `${url}/get-investments`,
  funds: `${url}/funds`,
  fundDetail: `${url}/fund-detail`,
  investorStatus: `${url}/investor-status`,
  holdings: `${url}/holdings`,
  fundCategory: `${url}/fund-category`,
  searchFunds: `${url}/search-funds`,
  sendOtpInvest: `${otp}/send-otp`,
  verifyOtpInvest: `${otp}/verify-otp`,
  resendOtpInvest: `${otp}/resend-otp`,
  orders: `${url}/orders`,
  listBank: `${otp}/list-bank`,
  listPaymentBank: `${url}/list-payments-bank`,
  initiatePayment: `${url}/initiate-payment`,
  addMandate: `${url}/bank-mandates`,
  virtualAccount: `${url}/virtual-account`,
  orderDetail: `${url}/order-detail`,
  panVerification: `${url}/kyc/pan-verification`,
  initiate: `${url}/kyc/initiate`,
  tarakkiKyc: `${url}/tarakki-kyc`,
  addBank: `${url}/investor/add-bank`,
  addNominee: `${url}/investor/add-nominee`,
  updateNominee: `${url}/investor/update-nominee`,
  investor: `${url}/investors`,
  documents: `${url}/investor/documents`,
  investorStatus: `${url}/investor-status`,
  getProfile: `${url}/get-profile`,
  investorStatus: `${url}/investor-status`,
  listNominee: `${url}/investor/list-nominee`,
  sips: `${url}/sips`,
  swps: `${url}/swps`,
  stps: `${url}/stps`,
  editBank: `${url}/investor/update-bank`,
  navData: `${url}/nav-data`,
  amcs: `${url}/amcs`,
  getInvestors: `${url}/investors`,
  wealthPlan: `${url}/create-wealth-plan`,
  getWealthPlan: `${url}/get-wealth-plan`,
  portfolioAnalysis: `${url}/portfolio-snapshot`,
  DeleteWealthPlan: `${url}/delete-wealth-plan`,
  transactionReport: `${url}/transactions-report`,
  ordersReport: `${url}/orders-report`,
  // BSE StARMF v2 UCC API endpoints
  getUcc: `${url}/bse/getUcc`,
  addNewUcc: `${url}/bse/addNewUcc`,
  uploadUccDocument: `${url}/api/bse/ucc/upload-document`,
  getMasterSchemes: `${url}/bse/getMasterSchemes`,
  fundDropdownData: `${url}/bse/getFundDropdownData`,
  getBseFundDetail: `${url}/bse/getFundDetail`,
  modifyOrAddNominee: `${url}/bse/modifyOrAddNominee`,
  getSchemeCategories: `${url}/bse/getSchemeCategories`,
  getFundReturns: `${url}/bse/getFundReturns`,
  bseAddNewOrder: `${url}/bse/addNewOrder`,
  bseGetExchPgService: `${url}/bse/getExchPgService`,
  bseSendPaymentInfo: `${url}/bse/sendPaymentInfo`,
  masterSchemeList: `${url}/bse/masterSchemeList`,
  bseGet2FAUccNom: `${url}/bse/get2FAUccNom`,
  bseGetOrder: `${url}/bse/getOrder`,
  bseGetAllOrders: `${url}/bse/getAllOrders`,
  mandateGetAll: `${url}/bse/mandateGetAll`,
  mandateRegister: `${url}/bse/mandateRegister`,
  saveMandateToDb: `${url}/bse/saveMandateToDb`,
  sxpRegister: `${url}/bse/sxpRegister`,
  verifySxpReg: `${url}/bse/get2FAUccNom`,
  getSxp: `${url}/bse/getSxp`,
  getAllSxpRegistrations: `${url}/bse/getAllSxpRegistrations`,
  mandateDetail: `${url}/bse/mandateDetail`,
  updateBankDetails: `${url}/bse/updateBankDetails`,
};

export default ApiConfig;
